import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminRoleEditTabs = ({
  roleId,
  activeTab,
  handleSwitchTab,
}) => {
  const intl = useIntl();

  return (
    <Nav tabs className="settings-tabs icon-tabs">
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'details' })}
          onClick={() => { handleSwitchTab('details'); }}
        >
          <i className="fa-solid fa-memo" />
          <span>{intl.formatMessage({ defaultMessage: 'Details' })}</span>
        </NavLink>
      </NavItem>
      {roleId && (
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === 'capabilities' })}
            onClick={() => { handleSwitchTab('capabilities'); }}
          >
            <i className="fa-solid fa-list-check" />
            <span>{intl.formatMessage({ defaultMessage: 'Capabilities' })}</span>
          </NavLink>
        </NavItem>
      )}
    </Nav>
  );
};

AdminRoleEditTabs.propTypes = {
  roleId: PropTypes.string,
  activeTab: PropTypes.string.isRequired,
  handleSwitchTab: PropTypes.func.isRequired,
};

AdminRoleEditTabs.defaultProps = {
  roleId: null,
};

export default AdminRoleEditTabs;
